/**
 * Action Types
 */

export const Types = {
    GET_REQUEST: 'pedidos/GET_REQUEST',
    ADD_PEDIDOS: 'pedidos/ADD_PEDIDOS',
    CLEAR_PEDIDOS: 'pedidos/CLEAR_PEDIDOS'
};

/**
 * Reducer
 */

const INITIAL_STATE = {
    list: {
        data: []
    },
    idStatusPedido: ''
};

export default function pedidos(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.GET_REQUEST:
            return { ...state, ...action.payload };
        case Types.ADD_PEDIDOS:
            return { ...state, ...action.payload };
        case Types.CLEAR_PEDIDOS:
            return { ...INITIAL_STATE };

        default:
            return state;
    }
}

/**
 * Action Creators
 */

export const Creators = {
    searchPedidos: (payload) => ({
        type: Types.GET_REQUEST,
        payload
    }),
    addPedidos: (payload) => ({
        type: Types.ADD_PEDIDOS,
        payload
    }),
    clearPedidos: () => ({
        type: Types.CLEAR_PEDIDOS
    })
};
